<template>
  <div class="" v-if="i18n !== undefined">
    <ranch-button
      :route="{ name: 'invoice.welcome', query: { credits: amount } }"
      :label="i18n.action_label"
      icon="plus-circle"
    />
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: Number,
      required: false,
    },
  },
  computed: {
    i18n() {
      return this.$store.state.safe.i18n.new_refill;
    },
  },
};
</script>
